"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const colors_1 = require("./colors");
require("./avatar.css");
/** Avatars are used to show a thumbnail representation of an individual or business in the interface. */
const Avatar = ({ size, className, children, backgroundColor, name = '', href, dataTest = 'avatar', type = 'div', ...other }) => {
    const removeDiacritics = (text) => text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .split('-')
        .join(' ')
        .split(' ');
    const sumChars = (text) => {
        return text.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
    };
    const parseInitials = (fullName) => {
        return fullName
            .map((n, i) => (i === 0 || i === fullName.length - 1) && n[0])
            .filter((n) => n)
            .join('')
            .toUpperCase();
    };
    const value = typeof children === 'string'
        ? parseInitials(removeDiacritics(children)).toString()
        : parseInitials(removeDiacritics(name)).toString();
    const color = colors_1.colors[sumChars(value) % colors_1.colors.length];
    const classes = (0, classnames_1.default)('dsc-avatar', size === 'small' || size === 'large' ? `is-${size}` : null, { 'is-link': type === 'link' }, backgroundColor ? `bg-${String(backgroundColor)}` : `bg-${String(color)}`, className);
    const Component = type === 'link' ? 'a' : type;
    const linkHref = type === 'link' && { href };
    return ((0, jsx_runtime_1.jsx)(Component, { ...other, ...linkHref, className: classes, "data-test": dataTest, children: (0, jsx_runtime_1.jsx)("div", { className: "dsc-avatar__content", children: children || (name && value) }) }));
};
exports.Avatar = Avatar;
exports.Avatar.displayName = 'Avatar';
//# sourceMappingURL=avatar.js.map